<template>
  <div class="inline" :class="{TA:isTestAchat}">
    <input name="file" id="file" type="file" @input="$emit('input', $event.target.files)" :disabled="loading || disabled"/>
    <label for="file" class="input" v-if="!loading" :class="{disabled: disabled}">{{ value }} <span class="button secondary">{{ $t('Contract.DeliveryAddress.moveFile.browse') }}</span></label>
    <label for="file" class="input" v-else-if="loading" :class="{disabled: disabled}"><span class="button secondary send">{{ $t('Contract.DeliveryAddress.moveFile.upload') }}</span> <SvgIcon class="loading" icon="loading"></SvgIcon></label>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    value: {
      type: String,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed:{
    ...mapGetters("subscription",  ["isTestAchat"])
  }
};
</script>

<style lang="scss" scoped>
input {
  display: none;
}

.input {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .button {
    padding: 2px;
    text-decoration: underline $yellow;
  
    &.send {
      text-decoration: none!important;
    }
  }

  &.disabled {
    border: 2px solid $grey;
    background: $lightGrey;

    .button {
      cursor: default;
      color: $grey;
      text-decoration: underline $grey;
    }
  }
}

.TA {
  .input {
    .button {
      text-decoration: underline $pink!important;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Form/BecomeFields/FileField.vue